import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { profitLossAction } from "../../redux/insightsAdvanced/actions";
import { ProfitLossPayload } from "../../commonTypes/insightAdvancedTypes";
import { resetProfiltLossData } from "../../redux/insightsAdvanced";
import Select from "react-select";
import {
  getCurrentFinancialYear,
  previousFinancialYear,
  previousTwoFinancialYear,
} from "../../utils/commonFunctions";

// current year
const currentYear = getCurrentFinancialYear();
let currentYearSlice = currentYear?.split("-");
let finacialYear = currentYearSlice[0] + "-" + currentYearSlice[1].slice(2, 4);

// previous year
const previousYear = previousFinancialYear();
let previousYearSlice = previousYear?.split("-");
let previousFinacialYear =
  previousYearSlice[0] + "-" + previousYearSlice[1].slice(2, 4);
  
// previous two year
const previousTwoYear = previousTwoFinancialYear();

let previousTwoYearSlice = previousTwoYear?.split("-");
let previousTwoFinacialYear =
  previousTwoYearSlice[0] + "-" + previousTwoYearSlice[1].slice(2, 4);

type DropDown = {
  label: string;
  value: string;
};

const fyDropDown: DropDown[] = [
  {
    label: "FY " + finacialYear,
    value: finacialYear,
  },
  {
    label: "FY " + previousFinacialYear,
    value: previousFinacialYear,
  },
  {
    label: " FY " + previousTwoFinacialYear,
    value: previousTwoFinacialYear,
  },
];

type AppProps = {
  dispatchProfitLossAction: (data: ProfitLossPayload) => void;
  history: any;
  token: string | null;
  profitLossData: [];
  dispatchResetProfiltLossData: () => void;
  client_code: number | undefined;
  company_name: string | undefined;
  currency: string | undefined;
};

const ProfitLoss = ({
  dispatchProfitLossAction,
  history,
  token,
  profitLossData,
  dispatchResetProfiltLossData,
  client_code,
  company_name,
  currency,
}: AppProps) => {
  const [monthList, setMonthList] = useState([]);
  const [expenseData, setExpenseData] = useState([]);
  const [revenuesData, setRevenuesData] = useState([]);

  const [changeYear, setChangeYear] = useState<DropDown>({
    label: "FY " + finacialYear,
    value: finacialYear,
  });

  useEffect(() => {
    dispatchResetProfiltLossData();
    if (client_code && token) {
      const payload = { client_code, token, FY: changeYear?.value };
      dispatchProfitLossAction(payload);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeYear]);

  useEffect(() => {
    if (profitLossData?.length) {
      const monthData: any = profitLossData?.map(function (item: any) {
        return item.month;
      });
      setMonthList(monthData);

      const expenseData: any = profitLossData?.map(function (item: any) {
        return item.total_expenses;
      });
      setExpenseData(expenseData);

      const revenuesData: any = profitLossData?.map(function (item: any) {
        return item.total_revenues;
      });
      setRevenuesData(revenuesData);
    }
  }, [profitLossData]);

  const option = {
    visualMap: [
      {
        show: false,
        type: "continuous",
      },
    ],
    tooltip: {
      trigger: "axis",
    },

    grid: {
      bottom: "20%",
      left: "10%",
      right: "5%",
    },
    xAxis: [
      {
        data: monthList?.length === 0 ? [] : monthList,

        boundaryGap: false,
        nameLocation: "middle",
        nameTextStyle: {
          width: 100,
          color: "#4e4b66",
          fontSize: "14px",
        },
        nameGap: 30,
      },
    ],

    yAxis: [
      {
        type: "value",
        axisLabel: {
          formatter: `${currency}{value}`,
        },
        nameLocation: "middle",
        nameTextStyle: {
          color: "#4e4b66",
          fontSize: "14px",
          fontFamily: "Poppins",
        },
        nameGap: 10,
      },
    ],

    series: [
      {
        name: "Sales",
        type: "line",
        smooth: 0.2,
        symbol: "none",
        lineStyle: {
          color: "#2080f6",
          width: 2.5,
        },
        areaStyle: {
          opacity: 0.2,
          color: "#2080f6",
        },
        data: revenuesData?.length === 0 ? [] : revenuesData,
      },
      {
        name: "Expense",
        type: "line",

        symbol: "none",
        smooth: 0.2,
        lineStyle: {
          color: "#ce2a96",
          width: 2.5,
        },
        areaStyle: {
          opacity: 0.2,
          color: "#ce2a96",
        },

        data: expenseData?.length === 0 ? [] : expenseData
      },
    ],
  };

  const handleDropChange = (e: DropDown) => {
    setChangeYear({
      label: e.label,
      value: e.value,
    });
  };
  return (
    <div>
      {" "}
      <div
        style={{ border: "1px solid #bfcbe1", borderRadius: "5px" }}
        className="mt-4 "
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="mt-2"
        >
          <div className="ml-3">
            <span style={{ fontSize: "18px", fontWeight: 500 }}>
              Sales vs Expense
            </span>
            <br></br>
            <span
              style={{ fontSize: "12px", color: "#6e7491", fontWeight: 500 }}
            >
              {changeYear?.label}
            </span>
          </div>
          <div className="mr-3 col-md-2">
            <Select
              value={changeYear}
              options={fyDropDown}
              onChange={(e: any) => handleDropChange(e)}
              isSearchable={false}
            />
          </div>
        </div>
        <ReactECharts
          option={option}
          style={{
            width: "100%",

            position: "relative",
            top: "10%",
            bottom: "10%",
          }}
        />
        <div
          style={{
            fontSize: "15px",
            justifyContent: "center",
          }}
          className="d-flex mt-3 mb-2"
        >
          <div
            className="mr-2"
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#2080f6",
            }}
          ></div>
          &nbsp;
          <span>Sales</span>
          &nbsp;
          <div
            className="ml-3"
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#ce2a96",
            }}
          ></div>
          &nbsp;
          <span className="ml-2">Expense</span>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  profitLossData: state.insightsAdvanced.profitLossData,
  currency: state.auth.currencySign,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchProfitLossAction: (data: any) => dispatch(profitLossAction(data)),
  dispatchResetProfiltLossData: () => dispatch(resetProfiltLossData()),
});
export default connect(mapStateToProps, mapDispatchToProps)(ProfitLoss);
